// sagas.js
import { call, put, select, takeLatest } from 'redux-saga/effects';
import { LOGIN_REQUEST, loginSuccess, loginFailure, LOGOUT, logout } from '../actions/actions';
import Axios from '../../utils/axiosInstance';

function* loginSaga(action) {
  try {
    const { email, password } = action.payload;
    const apiUrl = `${process.env.REACT_APP_API_BASE_URL}api/login/`;
    const response = yield call(Axios.post, apiUrl, { email, password });
   console.log(response.data.success)
    if (response.data.success) {
      yield put(loginSuccess(response.data.data)); // Pass token and user data
    } else {
      yield put(loginFailure(response.data.message || 'Login failed'));
    }
  } catch (error) {
    yield put(loginFailure(error.response?.data?.message || 'An error occurred'));
  }
}


export default function* watchAuth() {
  yield takeLatest(LOGIN_REQUEST, loginSaga);
}
